import { useState, useEffect, useCallback, useMemo } from "react";
import apiClient from "utils/apiClient";
import { useAuth } from "contexts/AuthContext";

const useUsers = (page = 0, pageSize = 20, initialStaff = null) => {
  const authToken = sessionStorage.getItem("authToken");
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [staffFilter, setStaffFilter] = useState(initialStaff); // Initialize with prop

  // Update staffFilter when initialStaff changes
  useEffect(() => {
    setStaffFilter(initialStaff);
  }, [initialStaff]);

  /** -------------------- Generic Helpers -------------------- **/

  const getRequest = useCallback(async (url) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get(url);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionalRequest = useCallback(async (url, fallbackValue = null) => {
    try {
      const response = await apiClient.get(url);
      return response.data;
    } catch (err) {
      if ([403, 404].includes(err?.response?.status)) {
        return fallbackValue;
      }
      throw err;
    }
  }, []);

  const postRequest = useCallback(async (url, payload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(url, payload);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const putRequest = useCallback(async (url, payload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.put(url, payload);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const patchRequest = useCallback(async (url, payload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.patch(url, payload);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteRequest = useCallback(async (url) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.delete(url);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteRequestWithoutLoading = useCallback(async (url, config = {}) => {
    try {
      const response = await apiClient.delete(url, config);
      return response.data;
    } catch (err) {
      throw err;
    }
  }, []);

//   /** -------------------- Fetch Users with Pagination -------------------- **/


  const [allUsersForStats, setAllUsersForStats] = useState([]);
// const fetchUsersAndStats = useCallback(async () => {
//   if (!authToken) return;

//   try {
//     setLoading(true);
//     setError(null);

//     const baseUrl = "/profile-service/api/v1/user-profiles";

//     // 1. Setup Params (Using the same pattern as health checks)
//     const tableParams = { 
//       page, 
//       size: pageSize, 
//       refresh: "true",
//       ...(staffFilter !== null && { staff: String(staffFilter) })
//     };

//     const statsParams = { 
//       unpaged: "true",
//       ...(staffFilter !== null && { staff: String(staffFilter) })
//     };

//     // 2. Execute both requests
//     const [tableResp, statsResp] = await Promise.all([
//       apiClient.get(baseUrl, { params: tableParams }),
//       apiClient.get(baseUrl, { params: statsParams }),
//     ]);

//     // 3. Handle Table Data (Using the "Health Check" defensive style)
//     const tableData = tableResp.data;
//     if (tableData.content) {
//       setUsers(tableData.content.map(formatUserData));
//       setTotalPages(tableData.totalPages);
//       setTotalElements(tableData.totalElements);
//     } else {
//       // Fallback if the API returns a raw array instead of a page object
//       const list = Array.isArray(tableData) ? tableData : [];
//       setUsers(list.map(formatUserData));
//       setTotalPages(1);
//       setTotalElements(list.length);
//     }

//     // 4. Handle Stats Data
//     const statsData = statsResp.data;
//     const allUsers = statsData.content ? statsData.content : (Array.isArray(statsData) ? statsData : []);
    
//     // This is the list your getStats() function will use
//     setAllUsersForStats(allUsers.map(formatUserData));

//   } catch (err) {
//     const errorMessage = err.response?.data?.message || err.message || "Failed to load users.";
//     setError(errorMessage);
//   } finally {
//     setLoading(false);
//   }
// }, [authToken, page, pageSize, staffFilter]);
// /** 1. Fetch Full Stats (Aggregated) **/
//   const fetchFullStats = useCallback(async () => {
//     if (!authToken) return;
//     try {
//       const baseUrl = "/profile-service/api/v1/user-profiles";
//       const params = { 
//         unpaged: "true", 
//         ...(staffFilter !== null && { staff: String(staffFilter) })
//       };

//       const res = await apiClient.get(baseUrl, { params });
//       const data = res.data.content || (Array.isArray(res.data) ? res.data : []);
//       setAllUsersForStats(data.map(formatUserData));
//     } catch (err) {
//       console.error("Stats fetch failed", err);
//     }
//   }, [authToken, staffFilter]);

//   /** 2. Fetch Table Data (Paginated) **/
//   const fetchTableData = useCallback(async () => {
//     if (!authToken) return;
//     setLoading(true);
//     try {
//       const baseUrl = "/profile-service/api/v1/user-profiles";
//       const params = { 
//         page, 
//         size: pageSize, 
//         refresh: "true",
//         ...(staffFilter !== null && { staff: String(staffFilter) })
//       };

//       const res = await apiClient.get(baseUrl, { params });
//       const content = res.data.content || [];
//       setUsers(content.map(formatUserData));
//       setTotalPages(res.data.totalPages || 1);
//       setTotalElements(res.data.totalElements || content.length);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [authToken, page, pageSize, staffFilter]);

//   /** 3. Unified Refetch (What the UI calls) **/
//   const refetchAll = useCallback(() => {
//     fetchTableData();
//     fetchFullStats();
//   }, [fetchTableData, fetchFullStats]);

//   /** 4. Triggers **/
//   useEffect(() => {
//     if (authToken) {
//       fetchTableData();
//     }
//   }, [authToken, fetchTableData]);

//   useEffect(() => {
//     if (authToken) {
//       fetchFullStats();
//     }
//   }, [authToken, fetchFullStats]);

  const searchUserProfiles = useCallback(
  async (query = "", status = "ALL", searchPage = 0) => {
    if (!authToken) return;

    const BASE_URL = `/profile-service/api/v1/user-profiles`;

    try {
      setLoading(true);
      setError(null);

      const trimmedQuery = query?.trim() || "";
      const hasQuery = trimmedQuery.length >= 3;
      const hasStatus = status && status !== "ALL";
      const hasStaff = staffFilter !== null;

      const params = new URLSearchParams({
        page: String(searchPage),
        size: String(pageSize),
      });

      if (hasQuery) {
        params.append("q", trimmedQuery);
      }

      if (hasStatus) {
        params.append("status", status);
      }

      if (hasStaff) {
        params.append("staff", String(staffFilter));
      }

      const endpoint =
        hasQuery || hasStatus || hasStaff
          ? `${BASE_URL}/search`
          : BASE_URL;

      const response = await apiClient.get(
        `${endpoint}?${params.toString()}`
      );

      const {
        content = [],
        totalPages = 1,
        totalElements = 0,
      } = response.data;

      const organizedUsers = content.map(formatUserData);

      setUsers(organizedUsers);
      setTotalPages(totalPages);
      setTotalElements(totalElements);

      return organizedUsers;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to search users. Please try again later.";

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  },
  [authToken, pageSize, staffFilter],
);

  const getUserById = useCallback(
    async (userId) => {
      if (!userId) throw new Error("User ID is required");

      const profileUrl = staffFilter
        ? `/profile-service/api/v1/user-profiles/${userId}?refresh=true&staff=true`
        : `/profile-service/api/v1/user-profiles/${userId}?refresh=true`;

      const [profileData, identityData, helperProfileData] = await Promise.all([
        getRequest(profileUrl),
        getRequest(`/identity-service/api/v1/users/${userId}?refresh=true`),
        getOptionalRequest(`/olitask-service/api/v1/helper-profiles/${userId}`),
      ]);

      const helperProfile =
        helperProfileData?.content && !Array.isArray(helperProfileData?.content)
          ? helperProfileData.content
          : helperProfileData;

      const mergedData = {
        ...profileData,
        statusChangeNotes: identityData.statusChangeNotes || null,
        helperProfile: helperProfile || null,
        helperProfileStatus:
          helperProfile?.helperStatus ||
          helperProfile?.status ||
          profileData?.helperProfileStatus ||
          null,
        helperStatusChangeNotes:
          helperProfile?.statusNotes ||
          helperProfile?.statusChangeNotes ||
          null,
      };
      return formatUserData(mergedData);
    },
    [getOptionalRequest, getRequest, staffFilter],
  );

  const getHelperProfileByUserId = useCallback(
    async (userId) => {
      if (!userId) throw new Error("User ID is required");
      const data = await getOptionalRequest(
        `/olitask-service/api/v1/helper-profiles/${userId}`,
      );
      if (!data) return null;
      if (data?.content && !Array.isArray(data.content)) return data.content;
      return data;
    },
    [getOptionalRequest],
  );

  /** -------------------- CRUD & Verification -------------------- **/

  const createUser = async (userData, profileData) => {
    const user = await postRequest(
      "/identity-service/api/v1/auth/signup",
      userData,
    );

    if (!user?.id) {
      throw new Error("User ID not returned from signup");
    }

    const profilePayload = buildProfilePayload(user, userData, profileData);
    const profileUrl =
      staffFilter === null
        ? "/profile-service/api/v1/user-profiles"
        : `/profile-service/api/v1/user-profiles?staff=${staffFilter}`;
    const profile = await postRequest(
      profileUrl,
      profilePayload,
    );

    return { success: true, user, profile };
  };

  const patchIdentityProperties = (userId, propertiesArray) =>
    patchRequest(
      `/identity-service/api/v1/users/props?uid=${userId}`,
      propertiesArray,
    );

  const patchProfileProperties = (userId, propertiesArray) =>
    patchRequest(
      `/profile-service/api/v1/user-profiles/props?uid=${userId}`,
      propertiesArray,
    );

  const verifyUserIdentity = (userId) =>
    postRequest(
      `/profile-service/api/v1/user-profiles/identity-verification/user/${userId}/verify`,
      {},
    );

  const verifyWorkAuthorization = (userId) =>
    postRequest(
      `/profile-service/api/v1/user-profiles/work-authorization/user/${userId}/verify`,
      {},
    );

  // Verify/unverify the main user profile
  const verifyUserProfile = (userId, verified = true) =>
    patchProfileProperties(userId, [{ op: 'replace', path: 'verified', value: verified }]);

  // Verify security photo
  const verifySecurityPhoto = (userId) =>
    postRequest(
      `/profile-service/api/v1/user-profiles/security-photo/user/${userId}/verify`,
      {},
    );

  const updateHelperProfileStatus = (userId, status, notes = null) => {
    if (!userId) throw new Error("User ID is required");
    if (!status) throw new Error("Helper profile status is required");

    return putRequest(
      `/olitask-service/api/v1/helper-profiles/${userId}/status`,
      {
        helperId: userId,
        status,
        notes,
      },
    );
  };

  const deleteUserProfileProperty = (userId) => {
    if (!authToken) throw new Error("Missing auth token");
    if (!user?.id) throw new Error("Missing actor id");
    return deleteRequestWithoutLoading(
      `/profile-service/api/v1/user-profiles?id=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "actor-id": user.id,
          "actor-id-type": "USER",
        },
      },
    );
  };

  /** -------------------- Auto Load -------------------- **/

  // useEffect(() => {
  //   if (authToken) {
  //     fetchUsersAndStats();
  //   }
  // }, [authToken, fetchUsersAndStats]);

  /** 1. Unified Fetch  **/
  const fetchAllUsers = useCallback(async () => {
    if (!authToken) return;
    setLoading(true);
    setError(null);

    try {
      const BASE_URL = "/profile-service/api/v1/user-profiles";

      // Request 1: The Paginated Page for the Table
      const tableParams = { 
        page, 
        size: pageSize, 
        refresh: "true",
        ...(staffFilter !== null && { staff: String(staffFilter) })
      };

  // Stats fetch
const statsParams = { 
  page: 0,
  size: 10000,  // fetch all users
  ...(staffFilter !== null && { staff: String(staffFilter) })
};

      // Execute both concurrently
      const [tableRes, statsRes] = await Promise.all([
        apiClient.get(BASE_URL, { params: tableParams }),
        apiClient.get(BASE_URL, { params: statsParams })
      ]);

      // Handle Table Data (Defensive Check like Health Check example)
      const tableData = tableRes.data;
      if (tableData.content) {
        setUsers(tableData.content.map(formatUserData));
        setTotalPages(tableData.totalPages);
        setTotalElements(tableData.totalElements);
      } else {
        const list = Array.isArray(tableData) ? tableData : [];
        setUsers(list.map(formatUserData));
        setTotalPages(1);
        setTotalElements(list.length);
      }

      // Handle Full Stats Data
      const statsData = statsRes.data;
      const fullList = statsData.content || (Array.isArray(statsData) ? statsData : []);
      setAllUsersForStats(fullList.map(formatUserData));

    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Failed to load users";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, [authToken, page, pageSize, staffFilter]);

  /** 2. Triggers **/
  useEffect(() => {
    fetchAllUsers();
  }, [fetchAllUsers]);

  /** 3. Refetch (What UI calls) **/
  const refetchAll = useCallback(() => {
    fetchAllUsers();
  }, [fetchAllUsers]);

  const getStats = useCallback(() => {
  if (!allUsersForStats || allUsersForStats.length === 0) return {};

  return allUsersForStats.reduce((acc, u) => {
    const status = u.status || "UNKNOWN";
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});
}, [allUsersForStats]);

const stats = useMemo(() => getStats(), [getStats]);


  /** -------------------- Return Object -------------------- **/

  return {
    users,
    loading,
    error,
    totalPages,
    totalElements,
    refetch: refetchAll,
    totalUsers: allUsersForStats.length || totalElements,
    activeUsers: allUsersForStats.filter((u) => u.status === "ACTIVE").length,
    verifiedUsers: allUsersForStats.filter((u) => u.verified).length,

    // Single user management
    getUserById,
    getHelperProfileByUserId,
    createUser,
    patchUserProperties: patchIdentityProperties,
    patchProfileProperties,
    verifyUserIdentity,
    verifyWorkAuthorization,
    verifyUserProfile,
    verifySecurityPhoto,
    updateHelperProfileStatus,
    deleteUserProfileProperty,
    searchUserProfiles,

    // getStats,

    allUsersForStats,

    // Staff filter
    staffFilter,
    setStaffFilter,
  };
};

/** -------------------- Helpers -------------------- **/

function formatUserData(user = {}) {
  const email =
    user.email ||
    user.contactDetails?.personalEmail ||
    user.contactDetails?.workEmail ||
    null;
  const phone =
    user.phone ||
    user.contactDetails?.mobilePhone ||
    user.contactDetails?.homePhone ||
    user.contactDetails?.workPhone ||
    null;

  return {
    id: user.id || "None",
    username: user.username || null,
    email: email || "None",
    phone: phone || "None",
    firstName: user.firstName || "None",
    middleName: user.middleName || "",
    lastName: user.lastName || "None",
    gender: user.gender || null,
    fullName:
      `${user.firstName || ""} ${user.middleName || ""} ${
        user.lastName || ""
      }`.trim() || "None",
    profilePhoto: user.profilePhoto || null,
    birthDate: user.birthDate || null,
    ssn: user.ssn || null,
    securityPhoto: user.securityPhoto || null,
    verified: Boolean(user.verified),
    status: user.status || "UNKNOWN",
    statusChangeNotes: user.statusChangeNotes || null,
    userIdentityVerification: user.userIdentityVerification || "pending",
    userWorkAuthorization: user.userWorkAuthorization || "None",
    completeProfile: computeProfileCompleteness(user),

    permanentAddress: user.permanentAddress || null,
    residentialAddress: user.residentialAddress || null,
    workAddress: user.workAddress || null,
    schoolAddress: user.schoolAddress || null,
    billingAddress: user.billingAddress || null,

    preferredMailingAddress: user.preferredMailingAddress || null,
    preferredContactMethod: user.preferredContactMethod || null,
    helperProfile: user.helperProfile || null,
    helperProfileStatus:
      user.helperProfileStatus ||
      user.helperProfile?.helperStatus ||
      user.helperProfile?.status ||
      null,
    helperApprovedAt:
      user.helperApprovedAt || user.helperProfile?.approvedAt || null,
    helperRejectedAt:
      user.helperRejectedAt || user.helperProfile?.rejectedAt || null,
    helperCreatedAt: user.helperCreatedAt || user.helperProfile?.createdAt || null,
    helperUpdatedAt:
      user.helperUpdatedAt ||
      user.helperProfile?.updatedAt ||
      user.helperProfile?.signedUpAt ||
      null,
    helperStatusChangeNotes:
      user.helperStatusChangeNotes ||
      user.helperProfile?.statusNotes ||
      user.helperProfile?.statusChangeNotes ||
      user.helperProfile?.notes ||
      null,
  };
}

function computeProfileCompleteness(user) {
  const required = [
    "firstName",
    "lastName",
    "email",
    "phone",
    "profilePhoto",
    "securityPhoto",
  ];
  const filled = required.filter((key) => user[key]);
  return Math.round((filled.length / required.length) * 100);
}

function buildProfilePayload(user, userData, profileData) {
  const contactDetails = {
    mobilePhone:
      profileData.contactDetails?.mobilePhone || userData.phone || "",
    homePhone: profileData.contactDetails?.homePhone || "",
    workPhone: profileData.contactDetails?.workPhone || "",
    personalEmail:
      profileData.contactDetails?.personalEmail || userData.email || "",
    email:
      profileData.contactDetails?.email ||
      profileData.workEmail ||
      userData.email ||
      "",
    website: profileData.contactDetails?.website || "",
    twitter: profileData.contactDetails?.twitter || "",
    facebook: profileData.contactDetails?.facebook || "",
    linkedin: profileData.contactDetails?.linkedin || "",
  };

  const buildAddress = (prefix) => ({
    street: profileData[`${prefix}Address`]?.street || "",
    city: profileData[`${prefix}Address`]?.city || "",
    state: profileData[`${prefix}Address`]?.state || "",
    zipCode: profileData[`${prefix}Address`]?.zipCode || "",
    country: profileData[`${prefix}Address`]?.country || "",
  });

  const permanentAddress = buildAddress("permanent");
  const residentialAddress = buildAddress("residential");
  const workAddress = buildAddress("work");
  const schoolAddress = buildAddress("school");
  const billingAddress = buildAddress("billing");

  const payload = {
    id: user.id,
    firstName: userData.firstName,
    middleName: userData.middleName || "",
    lastName: userData.lastName,
    username: userData.username,
    profilePhoto: profileData.profilePhoto || null,
    birthDate: profileData.birthDate || "",
    gender: profileData.gender ? profileData.gender.toUpperCase() : null,
    ssn: profileData.ssn || null,
    status: profileData.status || userData.status || "ACTIVE",
    nextOfKin: profileData.nextOfKin || null,
    identificationDocumentType: profileData.identificationDocumentType || null,
    userWorkAuthorization: profileData.userWorkAuthorization || null,
    contactDetails,
    permanentAddress,
    residentialAddress,
    workAddress,
    schoolAddress,
    billingAddress,
    preferredMailingAddress: profileData.preferredMailingAddress || null,
    preferredContactMethod: profileData.preferredContactMethod || null,
  };

  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([key, value]) => {
      if (value === null || value === "") return false;
      if (typeof value === "object" && !Array.isArray(value)) {
        if (
          [
            "permanentAddress",
            "residentialAddress",
            "workAddress",
            "schoolAddress",
            "billingAddress",
          ].includes(key)
        ) {
          return true;
        }
        return Object.values(value).some((val) => val !== null && val !== "");
      }
      return true;
    }),
  );

  return cleanPayload;
}

export default useUsers;
